import { Parameters } from 'DVWebNodeUtils'
import { makeUrl, MakeUrlArgs} from './urlGen'
import { getMarketplaceUrl } from '../marketplace'
export { makeUrl, MakeUrlArgs }

const detailPath = '/detail/'

export interface IUrlData {
  parameters: Parameters
  originalURI: string
  isRetail: boolean
}

export function buildSignInUrl(urlData: IUrlData, refTag: string, returnUrl: string) {
  return makeUrl('/auth-redirect', {
    urlData,
    refTag,
    get: { returnUrl, signin: '1' }
  })
}

export const detailPagePath = (titleId: string) => `${detailPath}${titleId}`

export function buildDetailPageUrl(urlData: IUrlData, titleId: string, refTag: string) {
  return makeUrl(detailPagePath(titleId), { urlData, refTag })
}

export function buildFullDetailPageUrl(urlData: IUrlData, titleId: string, refTag: string, marketplaceID: string) {
  // Gets the absolute url for the marketplace e.g. https://www.amazon.com for US
  const baseUrl = getMarketplaceUrl(marketplaceID)
  return `${baseUrl}${buildDetailPageUrl(urlData, titleId, refTag)}`
}
